module.exports = __webpack_public_path__ + "img/14.ff568fb9.png";